import {
  getPremium,
  getSpecialOffers,
  getSupplier,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import BenefitsComp from '@bridebook/web/app-basic/components/supplier/sections/benefits/benefits';

const Benefits = () => {
  const supplier = useSelector(getSupplier);
  const premium = useSelector(getPremium);
  const offers = useSelector(getSpecialOffers);

  return <BenefitsComp supplier={supplier as ISupplier} premium={premium} offers={offers} />;
};

export default Benefits;
